import * as signalR from "@microsoft/signalr";

let connection = null;

const start = async () => {
  if (connection && connection.state === signalR.HubConnectionState.Connected) {
    return connection;
  }

  // Remove /api from BASE_URL
  const hubUrl = window.env.BASE_URL.replace("/api", "") + "/NotificationHub";

  console.log("SignalR hub URL:", hubUrl);

  connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl)
    .withAutomaticReconnect([0, 2000, 5000, 10000])
    .configureLogging(signalR.LogLevel.Information)
    .build();

  connection.onreconnecting(() => {
    console.log("SignalR Reconnecting...");
  });

  connection.onreconnected(() => {
    console.log("SignalR Reconnected");
  });

  connection.onclose(() => {
    console.log("SignalR Closed");
  });

  await connection.start();

  console.log("SignalR Connected");

  return connection;
};

const getConnection = () => connection;

const leaveGroup = async (userId) => {
  if (connection && connection.state === signalR.HubConnectionState.Connected) {
    await connection.invoke("LeaveGroup", userId);
  }
};

const stop = async () => {
  if (connection) {
    await connection.stop();
    console.log("SignalR Disconnected");
  }
};

const SignalRService = { start, getConnection, leaveGroup, stop };

export default SignalRService;
